// extracted by mini-css-extract-plugin
export default {"item":"Relations_item__o79Ub"};